import React from "react";
import LoaderDots from "@swapcard-corporation/react-ui/lib/loader-dots";
import styled, { createGlobalStyle } from "styled-components";

const LoadingWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const GlobalStyle = createGlobalStyle`
  body {
    min-height: 100vh;
  }
`;

function Loading() {
  return (
    <LoadingWrapper>
      <GlobalStyle />
      <LoaderDots color="#555" />
    </LoadingWrapper>
  );
}

export default Loading;
